import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { push } from 'connected-react-router'
import { setDevice } from '../../../modules/device/actions/creators'

import MainView from '../components/MainView/MainView'
import { storeAccessToken } from '../../../services/data/accessToken'

const saveAccessToken = accessToken => {
  storeAccessToken(accessToken)
  return {
    type: '',
    payload: {},
  }
}
const mapStateToProps = reduxState => {
  const { registration, profile, device, auth } = reduxState
  const { accessToken, redirectAfterAuth } = auth
  const { primaryInfo } = profile
  const { step } = registration
  const { browser } = device

  return {
    accessToken,
    primaryInfo,
    step,
    browser,
    redirectAfterAuth,
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      push,
      setDevice,
      saveAccessToken,
    },
    dispatch,
  )

const ConnectedMainView = connect(mapStateToProps, mapDispatchToProps)(MainView)

export default ConnectedMainView
